import Vue from 'vue'
import valid_plugin from './plugin_def'
import API from '../api'

function define(id, cfg) {
    let plugin_id = id;
    let p = valid_plugin[plugin_id];
    let model = cfg.model;
    let mountedFunc = cfg.mounted;
    console.log(model);
    if (p) {
        if (!p.loaded) {
            if (document.querySelector(p.el)) {
                let view = new Vue({
                    el: p.el,
                    render: h => h(model),
                    mounted(){
                        mountedFunc();
                    }
                });
                p.loaded = true;
                console.log(view);
            }
        }
    } else {
        console.warn("the component is cannot define");
    }
}
export default {
    api: API,
    define: define
}